import { setFulfilled, setPending, setRejected } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { ResolveAttachableLinkAction } from '../../domains/resolveAttachableLink/actions.types';

import type { AttachableLinkReferenceLifecycle } from './types';

const initialState: AttachableLinkReferenceLifecycle = {
  pending: false,
  fulfilled: undefined,
  rejected: undefined,
};

export type AttachableLinkReferenceAction = ResolveAttachableLinkAction;

const reducer: Reducer<AttachableLinkReferenceLifecycle> = (
  state = initialState,
  action: AttachableLinkReferenceAction
) => {
  switch (action.type) {
    case 'ATTACHABLELINK.RESOLVE_PENDING':
      return setPending();
    case 'ATTACHABLELINK.RESOLVE_FULFILLED':
      return setFulfilled(action.payload.result);
    case 'ATTACHABLELINK.RESOLVE_REJECTED':
      return setRejected(action.payload.error);
    default:
      return state;
  }
};

export default reducer;
